import { useState } from 'react';

import EmailLeadForm from '~components/LeadForm/EmailLeadForm/EmailLeadForm';
import successIcon from '~images/common/circle-green-checkmark.svg';

type Props = { classname?: string; isvertical?: boolean; leadaction?: string };

const EnrollmentChecklist = ({ classname = '', isvertical = false, leadaction }: Props) => {
    const [isSucceeded, setIsSucceeded] = useState(false);

    return (
        <div className={classname} data-qa="checklist-email-cta">
            {!isSucceeded ? (
                <EmailLeadForm
                    uid="checklist-email-cta"
                    mktoFormId={1007}
                    buttonText="Get the checklist"
                    isStacked={isvertical}
                    leadInfo={{ leadStatus: 'NTMChecklist', advertiseSource: 'NTMList' }}
                    inputClasses="w-auto"
                    qaInput="checklist-email-textbox"
                    qaButton="checklist-email-submit"
                    waTracking="NTM checklist: Compare Plans"
                    beforeSubmit={() => setIsSucceeded(false)}
                    onSuccess={() => setIsSucceeded(true)}
                    {...(leadaction && { leadTrackingAction: { page: { action: leadaction } } })}
                />
            ) : (
                <div className="flex items-start" data-qa="checklist-email-success">
                    <img alt="" src={successIcon} width="30" height="45" className="mr-3" />
                    <p>
                        <span className="block font-bold text-xl md:text-2xl">Success!</span>
                        <span className="block text-base">Your Checklist has been sent!</span>
                    </p>
                </div>
            )}
        </div>
    );
};

export default EnrollmentChecklist;
